import React, { forwardRef } from 'react'

import Box from '@material-ui/core/Box'

const ColumnComponent = (props, ref) => <Box ref={ref} display='flex' flexDirection='column' {...props} />

export default forwardRef(ColumnComponent)
